import React from "react";
import { withRouter } from "react-router-dom";
import ImageBackground from "../common/imageBackground";
import ImageButtonList from "../common/imageButtonList";
import ImageButton from "../common/imageButton";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";
import AnswerPopup, {
  CorrectPopupType,
  IncorrectPopupType,
} from "./AnswerPopup";
import ElementsImage from "./images/1244_Comprehension_Elements.png";
import Question1 from "./images/Question1.png";
import Q1Answer1UH from "./images/Question1_A_UH.png";
import Q1Answer1HL from "./images/Question1_A_HL.png";
import Q1Answer2UH from "./images/Question1_B_UH.png";
import Q1Answer2HL from "./images/Question1_B_HL.png";
import Question2 from "./images/Question2.png";
import Q2Answer1UH from "./images/Question2_True_UH.png";
import Q2Answer1HL from "./images/Question2_True_HL.png";
import Q2Answer2UH from "./images/Question2_False_UH.png";
import Q2Answer2HL from "./images/Question2_False_HL.png";
import Question3 from "./images/Question3.png";
import Q3Answer1UH from "./images/Question3_A_UH.png";
import Q3Answer1HL from "./images/Question3_A_HL.png";
import Q3Answer2UH from "./images/Question3_B_UH.png";
import Q3Answer2HL from "./images/Question3_B_HL.png";
import Q3Answer3UH from "./images/Question3_C_UH.png";
import Q3Answer3HL from "./images/Question3_C_HL.png";
import Q3Answer4UH from "./images/Question3_D_UH.png";
import Q3Answer4HL from "./images/Question3_D_HL.png";
import SubmitScreen from "./images/1244_elements_comprehensive.png";

class ComprehensionQuestion extends React.Component {
  handleOnSelect = (id) => {
    this.state.questions[this.props.match.params.question - 1].answers.forEach(
      (answer, index) => {
        if (id === answer.id) {
          if (answer.correct) {
            this.setState({
              currentPopup: CorrectPopupType,
              continueLink: answer.next,
            });
          } else {
            this.setState({
              currentPopup: IncorrectPopupType,
              continueLink: answer.next,
              viewAgainLink: "/assigned_education/angiography/comprehension",
            });
          }
        }
      }
    );
  };

  /**************
   * Properties *
   **************/

  state = {
    currentPopup: "",
    continueLink: "",
    viewAgainLink: "",
    submitScreen: {
      id: "submit",
      to: "/assigned_education/prescribed_education",
      highlight: SubmitScreen,
      unhighlight: SubmitScreen,
      className: "submit-screen",
      current: true,
      resetCurrent: () => {},
    },
    questions: [
      {
        id: "question1",
        question: Question1,
        answers: [
          {
            id: "answer1",
            next: "/assigned_education/comprehension/2",
            highlight: Q1Answer1HL,
            unhighlight: Q1Answer1UH,
            handleSelect: this.handleOnSelect,
            correct: true,
          },
          {
            id: "answer2",
            next: "/assigned_education/comprehension/2",
            highlight: Q1Answer2HL,
            unhighlight: Q1Answer2UH,
            handleSelect: this.handleOnSelect,
            correct: false,
          },
        ],
      },
      {
        id: "question2",
        question: Question2,
        answers: [
          {
            id: "answer1",
            next: "/assigned_education/comprehension/3",
            highlight: Q2Answer1HL,
            unhighlight: Q2Answer1UH,
            handleSelect: this.handleOnSelect,
            correct: true,
          },
          {
            id: "answer2",
            next: "/assigned_education/comprehension/3",
            highlight: Q2Answer2HL,
            unhighlight: Q2Answer2UH,
            handleSelect: this.handleOnSelect,
            correct: false,
          },
        ],
      },
      {
        id: "question3",
        question: Question3,
        answers: [
          {
            id: "answer1",
            next: "/assigned_education/comprehension/submit",
            highlight: Q3Answer1HL,
            unhighlight: Q3Answer1UH,
            handleSelect: this.handleOnSelect,
            correct: false,
          },
          {
            id: "answer2",
            next: "/assigned_education/comprehension/submit",
            highlight: Q3Answer2HL,
            unhighlight: Q3Answer2UH,
            handleSelect: this.handleOnSelect,
            correct: false,
          },
          {
            id: "answer3",
            next: "/assigned_education/comprehension/submit",
            highlight: Q3Answer3HL,
            unhighlight: Q3Answer3UH,
            handleSelect: this.handleOnSelect,
            correct: false,
          },
          {
            id: "answer4",
            next: "/assigned_education/comprehension/submit",
            highlight: Q3Answer4HL,
            unhighlight: Q3Answer4UH,
            handleSelect: this.handleOnSelect,
            correct: true,
          },
        ],
      },
    ],
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.question !== this.props.match.params.question) {
      this.setState({
        currentPopup: "",
        continueLink: "",
        viewAgainLink: "",
      });
    }
  }

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const currentQuestionIndex =
      parseInt(this.props.match.params.question, 10) - 1;
    let isSubmitScreen = isNaN(currentQuestionIndex);
    return (
      <div className="comprehension-question">
        <ImageBackground id="background" />
        {!isSubmitScreen && (
          <div>
            <ImageText id="text" src={ElementsImage} />
            <img
              className={
                isSubmitScreen
                  ? "submit-screen"
                  : `question${currentQuestionIndex}`
              }
              src={
                isSubmitScreen
                  ? this.state.submitScreen
                  : this.state.questions[currentQuestionIndex].question
              }
              alt=""
            />
            <ImageButtonList
              id="comprehensionAnswers"
              imageButtons={this.state.questions[currentQuestionIndex].answers}
              flexClass="flex-vertical"
              disabled={this.state.currentPopup !== ""}
            />
          </div>
        )}
        {isSubmitScreen && <ImageButton {...this.state.submitScreen} />}
        <NavigationBar
          back={true}
          backRoute="/assigned_education/prescribed_education"
          mainMenu={true}
        />
        {this.state.currentPopup === CorrectPopupType && (
          <AnswerPopup
            type={CorrectPopupType}
            continueLink={this.state.continueLink}
          />
        )}
        {this.state.currentPopup === IncorrectPopupType && (
          <AnswerPopup
            type={IncorrectPopupType}
            continueLink={this.state.continueLink}
            viewAgainLink={this.state.viewAgainLink}
          />
        )}
      </div>
    );
  }
}

export default withRouter(ComprehensionQuestion);
